var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 26,
    viewBox: "0 0 18 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9107 8.71429C16.9107 12.9743 8.95536 25 8.95536 25C8.95536 25 1 12.9743 1 8.71429C1 4.45429 4.56223 1 8.95536 1C13.3485 1 16.9107 4.45429 16.9107 8.71429Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9555 10.4283C10.42 10.4283 11.6073 9.27705 11.6073 7.85689C11.6073 6.43673 10.42 5.28546 8.9555 5.28546C7.49096 5.28546 6.30371 6.43673 6.30371 7.85689C6.30371 9.27705 7.49096 10.4283 8.9555 10.4283Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.7e461f91ae17ffb328964c507fefaecd.svg";
export { ForwardRef as ReactComponent };